<template>
  <div class="root">
    <div @click="onClickQuiz()" class="quiz-item" :class="{ isOpen: isOpen }">
      <p class="quiz-inner">
        問題{{ index + 1 }}
        <img v-if="isCleared(quizItem.id)" src="@/assets/check.png" />
      </p>
      <img class="chev" src="@/assets/chevron.svg" />
    </div>
    <div v-show="isOpen">
      <div class="book-wrapper">
        <img class="book" src="@/assets/book.svg" />
        <div class="book-content-area">
          <div class="point-area">
            <p class="point-static-text">豆知識</p>
            <p>
              <span class="point-text">獲得ポイント</span>
              <img class="point-img" src="@/assets/point.png" />
              <span class="point">{{ quizItem.point }}</span>
            </p>
          </div>
          <p class="title">
            {{ quizItem.text }}
          </p>
          <p class="hint" v-if="quizItem.hint">
            <img src="@/assets/hint.svg" />
            {{ quizItem.hint }}
          </p>
        </div>
      </div>
      <ul class="option-list" v-if="!isCleared(quizItem.id)">
        <li
          v-for="option in quizItem.quiz_options"
          @click="onClickOption(option)"
          class="option"
          :class="{
            selected: !!selectedAnswer && selectedAnswer.text === option.text,
          }"
        >
          {{ option.text }}
        </li>
      </ul>
      <p v-else class="isCleared">達成済</p>

      <ButtonTextLink
        class="answer-button"
        v-if="!isCleared(quizItem.id)"
        text="回答する"
        :is-red="true"
        @click-text="onCickAnswer"
      />
      <AnswerModal
        v-if="isOpenAnswer"
        :option="selectedAnswer"
        :explanation="quizItem.explanation"
        @click-retry="onClickRetry"
        @click-get-point="onClickGetPoint"
      />
      <GetPointDailog
        v-if="isOpenGetPoint"
        :getPoint="quizItem.point"
        @click-close="onClickCloseGetPoint"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import TitleArea from "@/components/Atoms/TitleArea";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import Info from "@/components/QuizMission/Info";
import AnswerModal from "@/components/QuizMission/AnswerModal";
import GetPointDailog from "@/components/QuizMission/GetPointDailog";
import Firebase from "../../firebase";
import { QUIZ_MISSION_INTERVAL } from "../../const.js";

export default {
  name: "quiz-item",
  components: {
    TitleArea,
    ButtonTextLink,
    Info,
    AnswerModal,
    GetPointDailog,
  },
  props: {
    selectedMission: { type: Object, require: true },
    quizItem: { type: Object, require: true },
    index: { type: Number, require: true },
  },
  data() {
    return {
      isOpen: false,
      selectedAnswer: undefined,
      isOpenAnswer: false,
      isOpenGetPoint: false,
      clearMissionList: [],
    };
  },
  computed: {
    formattedCurrentDate() {
      const formattedCurrentDate = this.formatDateToCalc(new Date());
      return formattedCurrentDate;
    },
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini"]),
    isCleared(quiz_item_id) {
      return this.clearMissionList
        .filter((clearMission) => clearMission.quiz_item_id === quiz_item_id)
        .filter((mission) => {
          const formattedTargetDate = this.formatDateToCalc(
            new Date(mission.CreatedAt),
          );
          return (
            this.formattedCurrentDate - formattedTargetDate <
            QUIZ_MISSION_INTERVAL
          );
        }).length;
    },
    onClickQuiz() {
      this.isOpen = !this.isOpen;
    },
    onClickOption(option) {
      this.selectedAnswer = option;
    },
    onCickAnswer() {
      this.isOpenAnswer = true;
    },
    onClickRetry() {
      this.isOpenAnswer = false;
      this.selectedAnswer = undefined;
    },
    async onClickGetPoint() {
      this.loadingStartMini();
      await Firebase.clearQuizMission({
        mission_id: this.selectedMission.mission_id,
        quiz_item_id: this.quizItem.id,
        mission_title: this.selectedMission.mission_title,
        mission_point: this.quizItem.point,
        spot_id: this.selectedMission.spot,
        lat: this.targetLat,
        lon: this.targetLng,
      });
      this.clearMissionList = await Firebase.getQuizItemClearStatus(
        this.selectedMission.mission_id,
      );
      this.loadingEndMini();
      this.isOpenGetPoint = true;
    },
    onClickCloseGetPoint() {
      this.isOpenAnswer = false;
      this.selectedAnswer = undefined;
      this.isOpenGetPoint = false;
      this.isOpen = false;
    },
    formatDateToCalc(dt) {
      var y = String(dt.getFullYear());
      var m = String(("00" + (dt.getMonth() + 1)).slice(-2));
      var d = String(("00" + dt.getDate()).slice(-2));

      return Number(`${y}${m}${d}`);
    },
  },
  async mounted() {
    this.loadingStartMini();
    this.clearMissionList = await Firebase.getQuizItemClearStatus(
      this.selectedMission.mission_id,
    );
    this.loadingEndMini();
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.root {
  border-bottom: 1px #e7e7e7 solid;
}
.quiz-item {
  padding: 1rem;
  position: relative;
  display: flex;
  align-items: center;
  .quiz-inner {
    position: relative;
    display: flex;
    align-items: center;
  }
  p {
    display: inline-block;
    margin: 0;
    width: calc(100% - 1.5rem);
  }
  .chev {
    transform: rotate(-90deg);
    height: 0.5rem;
  }

  img {
    height: 1rem;
    margin-left: 1rem;
  }

  &.isOpen {
    color: #5cd5d6;
  }
}

.isCleared {
  color: #ff7e88;
  text-align: center;
}

.hint {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  color: #aaa;
  img {
    height: 1.2rem;
    margin-right: 0.5rem;
  }
}

.option-list {
  padding: 1rem 1.25rem;
  margin: 0 auto;

  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: #a3a3a3;
  .option {
    text-align: center;
    font-size: 1.1rem;
    border: 1px #a3a3a3 solid;
    border-radius: 4px;
    padding: 0.5rem 0.5rem;

    &.selected {
      border: 1px #5cd5d6 solid;
      background: #5cd5d6;
      color: white;
    }
  }
}

.answer-button {
  margin: 0.5rem auto;
  width: calc(100% - 1.25rem * 2);
}

.book-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  aspect-ratio: 700/400;
  z-index: -1;

  .book {
    width: 95vw;
    position: absolute;
    z-index: -1;
  }
  .book-content-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80vw;
    p {
      margin: 0.5rem 0;
    }

    .title {
      font-size: 1rem;
      margin: 0.25rem 0;
    }
    .point-area {
      margin-top: 1rem;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      background: #d8f2f2;
      width: 95%;
      padding: 0.25rem;

      p {
        margin: 0;
      }
      .point-static-text {
        font-size: 0.7rem;
        font-weight: 700;
      }

      .point-text {
        font-size: 0.7rem;
        margin-right: 0.5rem;
      }

      .point-img {
        height: 1.2rem;
        margin-right: -6px;
        margin-top: -3px;
      }
      .point {
        font-weight: 500;
        font-size: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuizMission/QuizItem.vue